export type SiteNavLink = {
  href: string
  label: string
}

/**
 * Marketing header + footer links. Array order is display order.
 *
 * These are the site's crawl spine: a public section that is not linked from
 * here is only reachable through the sitemap, and Google weights a page by
 * how it is linked. Keep every indexable hub on this list.
 */
export const SITE_NAV_LINKS: SiteNavLink[] = [
  { href: '/tools', label: 'Calculators' },
  { href: '/room-modes', label: 'Room sizes' },
  { href: '/gear', label: 'Gear' },
  { href: '/guides', label: 'Guides' },
  { href: '/glossary', label: 'Glossary' },
  { href: '/blog', label: 'Blog' },
  { href: '/authors', label: 'Authors' },
  { href: '/contact', label: 'Contact' },
]

/**
 * What the floating header itself carries — a handful, not the spine (owner,
 * 2026-09-26: the header had "way too many things crumpled up in it"). The
 * footer carries every SITE_NAV_LINKS entry on every page, so nothing here
 * costs the crawl anything.
 */
export const HEADER_NAV_LINKS: SiteNavLink[] = [
  { href: '/gear', label: 'Gear' },
  { href: '/tools', label: 'Calculators' },
  { href: '/guides', label: 'Guides' },
]

